// UserSessionsModal.jsx
import React, { useState } from 'react';
import { Modal, Table, Button, Alert } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { REST_API_URL } from '../../api/content-novareader';
import axios from 'axios';
import './sessions.css';


const UserSessionsModal = ({ open, onClose, sessions, noOfSessions, onSessionRemove }) => {
  const [sessionList, setSessionList] = useState(sessions || []);
  const [showLogin, setShowLogin] = useState(false);

    useEffect(() => {
        setSessionList(sessions || []);
    }, [sessions]);

  const removeSession = async (id) => {
    const updated = sessionList.filter(item => item.fuzzyId !== id);
    setSessionList(updated);
    setShowLogin(true);

    const response = await axios.delete(REST_API_URL+'/mysessions/'+id+'/remove', {}, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }; 

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'index',
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Linked Devices',
      dataIndex: 'userAgent',
    },
    {
      title: 'Action',
      render: (_, record) => (
        <Button danger icon={<DeleteOutlined />} onClick={() => removeSession(record.fuzzyId)} />
      ),
    },
  ];

  return (
    <Modal
      title="User Sessions"
      open={open}
      onCancel={onClose}
      footer={null}
    >
      <Alert
        message={`You’ve reached the maximum number of active devices(${noOfSessions}) for your account.`}
        description="To continue, please log out from another device or remove one from the list below."
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
      />

      <Table
        columns={columns}
        dataSource={sessionList}
        rowKey="id"
        pagination={false}
      />

      {showLogin && (
        <div style={{ marginTop: 20, textAlign: 'right' }}>
          <Button type="primary" onClick={() => window.location.href = '/'}>
            Login
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default UserSessionsModal;
